import React,{ useState, useEffect, useRef, useCallback} from 'react'
import style from './ConnectionProfile.module.css'
import { useLocation, useOutletContext } from "react-router-dom";
import Learningimg from "../../assests/learnings.png"
import Events from "../../assests/events.png"
import Oppertunity from "../../assests/opportunity.png"
import Mentors from "../../assests/mentor-experts.png"
import ProfileImage from '../../assests/Profile-PNG-File.png'
import { MdGroup } from "react-icons/md";
import { MdEventAvailable } from "react-icons/md";
import { GrMoney } from "react-icons/gr";
import {baseurl} from '../Url'
import Whiteboard from '../WhiteBoard/WhiteBoard';
import { BiClipboard } from "react-icons/bi";
import { AiOutlineClose } from "react-icons/ai";

import Loader from '../Loder/Loader';
import { MdMoreVert } from "react-icons/md";

const ConnectionProfile = () => {
    const OrgID=localStorage.getItem("ORGID") 
    const key = JSON.parse(localStorage.getItem("access-token"));
    const ClubID=localStorage.getItem("ClubID")

     const clubIdsArray = ClubID.split(',');
    
  const location=useLocation()
  const outletContext = useOutletContext();
  const onMenuToggle = outletContext?.onMenuToggle;
  const UserId=location.state?.userID
  const Role=location.state?.Role
  const[details,setDetails]=useState({})
  const[whiteBoradShow,setWhiteBoardShow]=useState(false)
  const[whiteBoradIconShow,setWhiteBoardIconShow]=useState(true)
  const [iconPosition, setIconPosition] = useState({ x: null, y: null });
  const iconRef = useRef(null);
  const iconDragRef = useRef(null);
  const mobileViewRef = useRef(typeof window !== "undefined" ? window.innerWidth <= 900 : false);
  const whiteboardRef = useRef(null);
  const whiteboardDragRef = useRef({ dragging: false, offsetX: 0, offsetY: 0 });
  const [whiteboardPosition, setWhiteboardPosition] = useState(null);

  const [closing, setClosing] = useState(false);

useEffect(()=>{
if(closing){
  setTimeout(() => {
    setClosing(false)
  }, 1000);
}
},[closing])

useEffect(() => {
  const syncViewportMode = () => {
    const mobile = window.innerWidth <= 900;
    if (mobile !== mobileViewRef.current) {
      mobileViewRef.current = mobile;
    }
  };

  syncViewportMode();
  window.addEventListener("resize", syncViewportMode);
  return () => window.removeEventListener("resize", syncViewportMode);
}, []);

useEffect(() => {
  const clampPosition = (x, y) => {
    const iconEl = iconRef.current;
    if (!iconEl) return { x, y };

    const rect = iconEl.getBoundingClientRect();
    const maxX = Math.max(0, window.innerWidth - rect.width - 8);
    const maxY = Math.max(0, window.innerHeight - rect.height - 8);
    return {
      x: Math.min(Math.max(8, x), maxX),
      y: Math.min(Math.max(8, y), maxY),
    };
  };

  const onMouseMove = (e) => {
    if (!iconDragRef.current) return;
    const { offsetX, offsetY, startClientX, startClientY, isDragging } = iconDragRef.current;
    if (!isDragging) {
      const movedX = Math.abs(e.clientX - startClientX);
      const movedY = Math.abs(e.clientY - startClientY);
      if (movedX < 4 && movedY < 4) return;
      iconDragRef.current.isDragging = true;
    }
    e.preventDefault();
    const nextX = e.clientX - offsetX;
    const nextY = e.clientY - offsetY;
    setIconPosition(clampPosition(nextX, nextY));
  };

  const onMouseUp = () => {
    iconDragRef.current = null;
  };

  const onTouchMove = (e) => {
    if (!iconDragRef.current || !e.touches?.[0]) return;
    const touch = e.touches[0];
    const { offsetX, offsetY, startClientX, startClientY, isDragging } = iconDragRef.current;
    if (!isDragging) {
      const movedX = Math.abs(touch.clientX - startClientX);
      const movedY = Math.abs(touch.clientY - startClientY);
      if (movedX < 4 && movedY < 4) return;
      iconDragRef.current.isDragging = true;
    }
    const nextX = touch.clientX - offsetX;
    const nextY = touch.clientY - offsetY;
    setIconPosition(clampPosition(nextX, nextY));
  };

  const onTouchEnd = () => {
    iconDragRef.current = null;
  };

  const onResize = () => {
    setIconPosition((prev) => {
      if (prev.x === null || prev.y === null) return prev;
      return clampPosition(prev.x, prev.y);
    });
    setWhiteboardPosition((prev) => {
      if (!prev || !whiteboardRef.current) return prev;
      const rect = whiteboardRef.current.getBoundingClientRect();
      const margin = 8;
      const maxX = Math.max(margin, window.innerWidth - rect.width - margin);
      const maxY = Math.max(margin, window.innerHeight - rect.height - margin);
      return {
        x: Math.max(margin, Math.min(prev.x, maxX)),
        y: Math.max(margin, Math.min(prev.y, maxY)),
      };
    });
  };

  window.addEventListener("mousemove", onMouseMove);
  window.addEventListener("mouseup", onMouseUp);
  window.addEventListener("touchmove", onTouchMove, { passive: false });
  window.addEventListener("touchend", onTouchEnd);
  window.addEventListener("resize", onResize);
  return () => {
    window.removeEventListener("mousemove", onMouseMove);
    window.removeEventListener("mouseup", onMouseUp);
    window.removeEventListener("touchmove", onTouchMove);
    window.removeEventListener("touchend", onTouchEnd);
    window.removeEventListener("resize", onResize);
  };
}, []);

const handleIconDragStart = (e) => {
  const iconEl = iconRef.current;
  if (!iconEl) return;
  const rect = iconEl.getBoundingClientRect();
  iconDragRef.current = {
    offsetX: e.clientX - rect.left,
    offsetY: e.clientY - rect.top,
    startClientX: e.clientX,
    startClientY: e.clientY,
    isDragging: false,
  };
};

const handleIconTouchStart = (e) => {
  const touch = e.touches?.[0];
  const iconEl = iconRef.current;
  if (!touch || !iconEl) return;
  const rect = iconEl.getBoundingClientRect();
  iconDragRef.current = {
    offsetX: touch.clientX - rect.left,
    offsetY: touch.clientY - rect.top,
    startClientX: touch.clientX,
    startClientY: touch.clientY,
    isDragging: false,
  };
};

const handleWhiteboardDragStart = useCallback((e) => {
  if (e.button !== 0) return;
  const wb = whiteboardRef.current;
  if (!wb) return;
  const rect = wb.getBoundingClientRect();
  whiteboardDragRef.current = {
    dragging: true,
    offsetX: e.clientX - rect.left,
    offsetY: e.clientY - rect.top,
  };
  setWhiteboardPosition({ x: rect.left, y: rect.top });
  e.preventDefault();
}, []);

const handleWhiteboardTouchStart = useCallback((e) => {
  const touch = e.touches?.[0];
  const wb = whiteboardRef.current;
  if (!touch || !wb) return;
  const rect = wb.getBoundingClientRect();
  whiteboardDragRef.current = {
    dragging: true,
    offsetX: touch.clientX - rect.left,
    offsetY: touch.clientY - rect.top,
  };
  setWhiteboardPosition({ x: rect.left, y: rect.top });
}, []);

useEffect(() => {
  const onWhiteboardMouseMove = (e) => {
    if (!whiteboardDragRef.current.dragging) return;
    const wb = whiteboardRef.current;
    if (!wb) return;
    const rect = wb.getBoundingClientRect();
    const margin = 8;
    const maxX = Math.max(margin, window.innerWidth - rect.width - margin);
    const maxY = Math.max(margin, window.innerHeight - rect.height - margin);
    const nextX = Math.max(margin, Math.min(e.clientX - whiteboardDragRef.current.offsetX, maxX));
    const nextY = Math.max(margin, Math.min(e.clientY - whiteboardDragRef.current.offsetY, maxY));
    setWhiteboardPosition({ x: nextX, y: nextY });
  };

  const onWhiteboardTouchMove = (e) => {
    if (!whiteboardDragRef.current.dragging) return;
    const wb = whiteboardRef.current;
    const touch = e.touches?.[0];
    if (!wb || !touch) return;
    const rect = wb.getBoundingClientRect();
    const margin = 8;
    const maxX = Math.max(margin, window.innerWidth - rect.width - margin);
    const maxY = Math.max(margin, window.innerHeight - rect.height - margin);
    const nextX = Math.max(margin, Math.min(touch.clientX - whiteboardDragRef.current.offsetX, maxX));
    const nextY = Math.max(margin, Math.min(touch.clientY - whiteboardDragRef.current.offsetY, maxY));
    setWhiteboardPosition({ x: nextX, y: nextY });
    e.preventDefault();
  };

  const stopWhiteboardDrag = () => {
    whiteboardDragRef.current.dragging = false;
  };

  window.addEventListener("mousemove", onWhiteboardMouseMove);
  window.addEventListener("mouseup", stopWhiteboardDrag);
  window.addEventListener("touchmove", onWhiteboardTouchMove, { passive: false });
  window.addEventListener("touchend", stopWhiteboardDrag);
  window.addEventListener("touchcancel", stopWhiteboardDrag);
  return () => {
    window.removeEventListener("mousemove", onWhiteboardMouseMove);
    window.removeEventListener("mouseup", stopWhiteboardDrag);
    window.removeEventListener("touchmove", onWhiteboardTouchMove);
    window.removeEventListener("touchend", stopWhiteboardDrag);
    window.removeEventListener("touchcancel", stopWhiteboardDrag);
  };
}, []);


  async function userDetails() {
    await fetch(`${baseurl}/main/dashboard/all`, {
      method: "POST",
      body: JSON.stringify({
        user_id:UserId,
        org_id:OrgID,
        club_id:clubIdsArray
      }),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setDetails(data.data[0])
        
      });
  }
  useEffect(()=>{
    userDetails()
  },[])
  return (
    <div className={style.Container}>
      {whiteBoradIconShow  ? (
        <div
          ref={iconRef}
          className={style.chatboticon}
          style={
            iconPosition.x !== null && iconPosition.y !== null
              ? { left: `${iconPosition.x}px`, top: `${iconPosition.y}px`, right: "auto", transform: "none" }
              : undefined
          }
          onMouseDown={handleIconDragStart}
          onTouchStart={handleIconTouchStart}
        >
          <div onClick={()=>{
        setIconPosition({ x: null, y: null });
        setWhiteBoardShow(true)
        setWhiteBoardIconShow(false)
      }}  className={style.icontext}>
       <BiClipboard className={style.WhiteboardFloatingIcon} /><p> Whiteboard</p>
      </div>
         
        </div>
      ) : (
        ""
      )}

{whiteBoradShow?
      <div
        ref={whiteboardRef}
        className={`${style.WhiteBoradContainer} ${closing ? style.closing : ''}`}
        style={whiteboardPosition ? { left: `${whiteboardPosition.x}px`, top: `${whiteboardPosition.y}px`, right: "auto", transform: "none" } : undefined}
      >
        <div
          className={style.WhiteBoradHead}
          onMouseDown={handleWhiteboardDragStart}
          onTouchStart={handleWhiteboardTouchStart}
        >
          <div className={style.HeadText}>
            White Board
          </div>
          <div
            className={style.WhiteBoradIcon}
            onMouseDown={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
            onClick={() => {
              setTimeout(() => {
                setIconPosition({ x: null, y: null });
                setWhiteBoardIconShow(true)
              setWhiteBoardShow(false)
              }, 500);
              setClosing(true);
            }}
          >
            <AiOutlineClose />
          </div>
        </div>
        <div className={style.WhiteBoradContent} >
        <Whiteboard/>
        
        </div>

      </div>
      :''}
        <div className={style.Content}>
        <>
        <div className={style.profile}>
        {details.profile?
              <>
              <div className={style.color}>
          <button
            type="button"
            className={style.peerProfileMenuBtn}
            onClick={onMenuToggle}
            aria-label="Open menu"
          >
            <MdMoreVert size={22} />
          </button>
          <div className={style.profileimage}>
                <div className={style.ProfileImageDiv}>
                {details.profile.image ? (
      <img src={details.profile.image} />
    ) : (
      <img src={ProfileImage} />
    )}
                  </div>
              </div>
       </div>
            <div className={style.ProfileDetails}>
              <div className={style.Edit}>
              <h2>{details.profile.Name}</h2>
              </div>
              
              <p>{details.profile.About}</p>
              <div className={style.MainText}>
                <div className={style.FirstText}>Full Name</div>
                <div className={style.SecondText}>: {details.profile.Fullname} </div>
              </div>
              <div className={style.MainText}>
                <div className={style.FirstText}>Phone</div>
                <div className={style.SecondText}>: {details.profile.Contact}</div>
              </div>
              <div className={style.MainText}>
                <div className={style.FirstText}>Experience</div>
                <div className={style.SecondText}>: {details.profile.Expirence}</div>
              </div>
              <div className={style.MainText}>
                <div className={style.FirstText}>About Experience</div>
                <div className={style.SecondText}>: {details.profile.About_exp}</div>
              </div>
              <div className={style.MainText}>
                <div className={style.FirstText}>Email</div>
                <div className={style.SecondText}>: {details.profile.Email}</div>
              </div>
            </div>
              </>
              :''
            }
       
        </div>
            {Role==="Mentor"?
            <div className={style.Analytics}>
          <div className={style.AnalyticsHead}>
            <p>Analytics</p>
          </div>
          <div className={style.analyticContent}>
           <div className={style.AnalyticsCard}>
            <div className={style.CardIcons}>
                 
                  <MdGroup style={{fontSize:"1.75rem"}}/>
            </div>
            <div className={style.AnalyticsCardcontent}>
            <p><span className={style.boldnumber}>{details.Total_leaners_mapped}</span> Assigned members</p>
            </div>
            </div>
            <div className={style.AnalyticsCard}>
            <div className={style.CardIcons}>
                 
                  <MdEventAvailable style={{fontSize:"1.75rem"}}/>
            </div>
            <div className={style.AnalyticsCardcontent}>
            <p><span className={style.boldnumber}>{details.sessions}</span> Session Conducted</p>
            </div>
            </div>
            <div className={style.AnalyticsCard}>
            <div className={style.CardIcons}>
                  <img src={Oppertunity}/>
            </div>
            <div className={style.AnalyticsCardcontent}>
            <p><span className={style.boldnumber}>25</span>Member Goals Achieved </p>
            </div>
            </div>
            <div className={style.AnalyticsCard}>
            <div className={style.CardIcons}>
                  
                  <GrMoney style={{fontSize:"1.75rem"}}/>
            </div>
            <div className={style.AnalyticsCardcontent}>
            <p><span className={style.boldnumber}>25</span> Total Earnings /Hr</p>
            </div>
            </div>

          </div>
        </div>
        :
        <div className={style.Analytics}>
          <div className={style.AnalyticsHead}>
            <p>Analytics</p>
          </div>
          <div className={style.analyticContent}>
           <div className={style.AnalyticsCard}>
            <div className={style.CardIcons}>
                  <img src={Learningimg}/>
            </div>
            <div className={style.AnalyticsCardcontent}>
            <p><span className={style.boldnumber}>{details.Total_Learnings_Attended}</span> learning Attended</p>
            </div>
            </div>
            <div className={style.AnalyticsCard}>
            <div className={style.CardIcons}>
                  <img src={Mentors}/>
            </div>
            <div className={style.AnalyticsCardcontent}>
            <p><span className={style.boldnumber}>{details.Total_Mentor_Assigned}</span> Mentors & Experts Assigned</p>
            </div>
            </div>
            <div className={style.AnalyticsCard}>
            <div className={style.CardIcons}>
                  <img src={Oppertunity}/>
            </div>
            <div className={style.AnalyticsCardcontent}>
            <p><span className={style.boldnumber}>{details.Opportunities_Used}</span> Opportunity used  </p>
            </div>
            </div>
            <div className={style.AnalyticsCard}>
            <div className={style.CardIcons}>
                  <img src={Events}/>
            </div>
            <div className={style.AnalyticsCardcontent}>
            <p><span className={style.boldnumber}>{details.sessions}</span> Session Conducted</p>
            </div>
            </div>

          </div>

        </div>
         }
        </> 
      </div>
    </div>
  )
}

export default ConnectionProfile